import { Navigate, Outlet, RouteObject } from "react-router-dom";
import Auth from "./Auth";
import Layout from "./Layout";
import Login from "./Login";
import ProtectedRoute from "./ProtectedRoute";
import SignUp from "./SignUp";
import AssetExclusionInfo from "./billing/AssetExclusionInfo";
import AssetExclusionTable from "./billing/AssetExclusionTable";
import BillingMinimumInfo from "./billing/BillingMinimumInfo";
import BillingMinimumTable from "./billing/BillingMinimumTable";
import BillingReportInfo from "./billing/BillingReportInfo";
import BillingReportsTable from "./billing/BillingReportsTable";
import BillingSplitsInfo from "./billing/BillingSplitsInfo";
import BillingSplitsTable from "./billing/BillingSplitsTable";
import BillingSummary from "./billing/BillingSummary";
import CreateBillingReport from "./billing/CreateBillingReport";
import FeeStructureInfo from "./billing/FeeStructureInfo";
import FeeStructureTable from "./billing/FeeStructureTable";
import AccountCashSettings from "./cash/AccountCashSettings";
import CashSettingInfo from "./cash/CashSettingInfo";
import CashSettings from "./cash/CashSettings";
import CreateForecastedTransfer from "./cash/CreateForecastedTransfer";
import RecurringCashPredictions from "./cash/RecurringCashPredictions";
import AccountActivity from "./clients/account/AccountActivity";
import AccountCashBillingSettings from "./clients/account/AccountCashBillingSettings";
import AccountInfo from "./clients/account/AccountInfo";
import AccountModelTrading from "./clients/account/AccountModelTrading";
import AccountOverview from "./clients/account/AccountOverview";
import AccountPortfolio from "./clients/account/AccountPortfolio";
import AccountProfile from "./clients/account/AccountProfile";
import AccountTax from "./clients/account/AccountTax";
import AccountTransactions from "./clients/account/AccountTransactions";
import Accounts from "./clients/account/Accounts";
import AccountsHouseholdsMapping from "./clients/account/AccountsHouseholdsMapping";
import BulkTaxClassification from "./clients/account/BulkTaxClassification";
import GoRedirect from "./clients/goRedirect";
import ContactInfo from "./clients/contact/ContactInfo";
import ContactMapping from "./clients/contact/ContactMapping";
import Contacts from "./clients/contact/Contacts";
import CreateContact from "./clients/contact/CreateContact";
import CreateHousehold from "./clients/household/CreateHousehold";
import HouseholdAccountCashSettings from "./clients/household/HouseholdAccountCashSettings";
import HouseholdActivity from "./clients/household/HouseholdActivity";
import HouseholdCashBilling from "./clients/household/HouseholdCashBilling";
import HouseholdInfo from "./clients/household/HouseholdInfo";
import HouseholdMapping from "./clients/household/HouseholdMapping";
import HouseholdModelTrading from "./clients/household/HouseholdModelTrading";
import HouseholdOverview from "./clients/household/HouseholdOverview";
import HouseholdPortal from "./clients/household/HouseholdPortal";
import HouseholdPortfolio from "./clients/household/HouseholdPortfolio";
import HouseholdProfile from "./clients/household/HouseholdProfile";
import HouseholdTasks from "./clients/household/HouseholdTasks";
import HouseholdTax from "./clients/household/HouseholdTax";
import HouseholdTransactions from "./clients/household/HouseholdTransactions";
import Households from "./clients/household/Households";
import HouseholdGroupInfo from "./clients/household-group/HouseholdGroupInfo";
import HouseholdGroups from "./clients/household-group/HouseholdGroups";
import AssignedTasks from "./dashboard/AssignedTasks";
import ClientSummary from "./dashboard/ClientSummary";
import FirmSummary from "./dashboard/FirmSummary";
import TransactionSummary from "./dashboard/TransactionSummary";
import FirmActivity from "./firm/FirmActivity";
import FirmHeading from "./firm/FirmHeading";
import FirmInfo from "./firm/FirmInfo";
import FirmRisk from "./firm/FirmRisk";
import FirmRiskAssetClass from "./firm/FirmRiskAssetClass";
import FirmRiskSecurityCategory from "./firm/FirmRiskSecurityCategory";
import MinimumTradeSizes from "./firm/MinimumTradeSizes";
import RiskAllocationsAssetClass from "./firm/RiskAllocationsAssetClass";
import SecurityMaster from "./firm/SecurityMaster";
import CategoryAssetClass from "./firm/SecurityCategoryAssetClass";
import SecurityDetails from "./securities/SecurityDetails";
import SlantBillingFields from "./firm/SlantBillingFields";
import BenchmarkInfo from "./models/BenchmarkInfo";
import Benchmarks from "./models/Benchmarks";
import ModelInfo from "./models/ModelInfo";
import Models from "./models/Models";
import SecurityGroupInfo from "./models/SecurityGroupInfo";
import SecurityGroups from "./models/SecurityGroups";
import SleeveInfo from "./models/SleeveInfo";
import ModelSleeves from "./models/Sleeves";
import CreateUser from "./profile/CreateUser";
import IntegrationCredentials from "./profile/IntegrationCredentials";
import UserProfile from "./profile/UserProfile";
import CreateRebalance from "./rebalances/CreateRebalance";
import ManualRebalanceGenerator from "./rebalances/ManualRebalanceGenerator";
import PositionSwap from "./rebalances/PositionSwap";
import PositionSwaps from "./rebalances/PositionSwaps";
import RebalanceHouseholdCashBilling from "./rebalances/RebalanceHouseholdCashBilling";
import RebalanceHouseholdExplain from "./rebalances/RebalanceHouseholdExplain";
import RebalanceHouseholdExplainV3 from "./rebalances/explain/RebalanceHouseholdExplain";
import RebalanceHouseholdDetails from "./rebalances/RebalanceHouseholdDetails";
import RebalanceHouseholdModelTrading from "./rebalances/RebalanceHouseholdModelTrading";
import RebalanceInfo from "./rebalances/RebalanceInfo";
import RebalanceSummary from "./rebalances/RebalanceSummary";
import RebalanceTrades from "./rebalances/RebalanceTrades";
import RebalancesApproved from "./rebalances/RebalancesApproved";
import RebalancesExecuted from "./rebalances/RebalancesExecuted";
import RebalancesFuture from "./rebalances/RebalancesFuture";
import RebalancesToday from "./rebalances/RebalancesToday";
import ReleaseLog from "./release-notes/ReleaseLog";
import CreateReport from "./reports/CreateReport";
import DataExports from "./reports/DataExports";
import Export13f from "./reports/Export13f";
import Filing13f from "./reports/Filing13f";
import ExportAccountBalances from "./reports/ExportAccountBalances";
import ExportAccountPositions from "./reports/ExportAccountPositions";
import ExportFirmPositions from "./reports/ExportFirmPositions";
import ReportBatchInfo from "./reports/ReportBatchInfo";
import ReportBatches from "./reports/ReportBatches";
import ReportInfo from "./reports/ReportInfo";
import ReportTemplateInfo from "./reports/ReportTemplateInfo";
import ReportTemplates from "./reports/ReportTemplates";
import FirmRMDReport from "./reports/FirmRMDReport";
import AdminRebalanceExplain from "./admin/AdminRebalanceExplain";
import AdminRebalanceList from "./admin/AdminRebalanceList";
import AdminShell from "./admin/AdminShell";
import StaffRoute from "./admin/StaffRoute";
import AdminDocsRoute from "./docs/AdminDocsRoute";
import DocsPage from "./docs/DocsPage";
import HelpArticle from "./help/HelpArticle";
import HelpIndex from "./help/HelpIndex";
import HelpLayout from "./help/HelpLayout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: "/login", element: <Login /> },
      { path: "/signup", element: <SignUp /> },
      /* 
        The /auth route receives the redirect code following
        authentication from Auth0 so that the Auth0Provider component
        has an entry point to navigate React Router to the initial page.
      */
      {
        path: "/auth/:service",
        element: (
          <ProtectedRoute>
            <Auth />
          </ProtectedRoute>
        ),
      },
      {
        path: "/dashboard/*",
        element: (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
        handle: { crumb: () => "Home" },
        children: [
          { index: true, element: <Navigate to="firm" replace /> },
          {
            path: "firm",
            element: <FirmSummary />,
            handle: { crumb: () => "Firm Summary" },
          },
          {
            path: "clients",
            element: <ClientSummary />,
            handle: { crumb: () => "Households" },
          },
          {
            path: "transactions",
            element: <TransactionSummary />,
            handle: { crumb: () => "Transactions" },
          },
          {
            path: "tasks",
            element: <AssignedTasks />,
            handle: { crumb: () => "Tasks" },
          },
        ],
      },
      {
        path: "models/*",
        element: (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
        handle: { crumb: () => "Models" },
        children: [
          { index: true, element: <Navigate to="models" replace /> },
          {
            path: "models",
            element: <Outlet />,
            handle: { crumb: () => "Models" },
            children: [
              { index: true, element: <Models /> },
              {
                path: ":modelId",
                element: <ModelInfo />,
                handle: { crumb: () => "Details" },
              },
            ],
          },
          {
            path: "sleeves",
            element: <Outlet />,
            handle: { crumb: () => "Sleeves" },
            children: [
              { index: true, element: <ModelSleeves /> },
              {
                path: ":sleeveId",
                element: <SleeveInfo />,
                handle: { crumb: () => "Details" },
              },
            ],
          },
          {
            path: "security-groups",
            element: <Outlet />,
            handle: { crumb: () => "Security Groups" },
            children: [
              { index: true, element: <SecurityGroups /> },
              {
                path: ":securityGroupId",
                element: <SecurityGroupInfo />,
                handle: { crumb: () => "Details" },
              },
            ],
          },
          {
            path: "benchmarks",
            element: <Outlet />,
            handle: { crumb: () => "Benchmarks" },
            children: [
              { index: true, element: <Benchmarks /> },
              {
                path: ":benchmarkId",
                element: <BenchmarkInfo />,
                handle: { crumb: () => "Details" },
              },
            ],
          },
        ],
      },
      {
        path: "rebalances/*",
        element: (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
        handle: { crumb: () => "Trade Proposals" },
        children: [
          { index: true, element: <Navigate to="today" replace /> },
          {
            path: "today",
            element: <RebalancesToday />,
            handle: { crumb: () => "Suggested" },
          },
          {
            path: "approved",
            element: <RebalancesApproved />,
            handle: { crumb: () => "Approved" },
          },
          {
            path: "executed",
            element: <RebalancesExecuted />,
            handle: { crumb: () => "Executed" },
          },
          {
            path: "future",
            element: <RebalancesFuture />,
            handle: { crumb: () => "Future" },
          },
          {
            path: "new",
            element: <CreateRebalance />,
            handle: { crumb: () => "New" },
          },
          ...(process.env.REACT_APP_FEATURE_MANUAL_REBALANCE !== "true"
            ? []
            : [
                {
                  path: "manual",
                  element: <ManualRebalanceGenerator />,
                  handle: { crumb: () => "Manual" },
                },
              ]),
          {
            path: "position-swaps",
            element: <PositionSwaps />,
            handle: { crumb: () => "Position swaps" },
          },
          {
            path: "position-swaps/:swapId",
            element: <PositionSwap />,
            handle: { crumb: () => "Position swap" },
          },
          {
            path: ":rebalanceId",
            element: <RebalanceInfo />,
            handle: { crumb: () => "Details" },
            children: [
              { index: true, element: <Navigate to="overview" replace /> },
              { path: "overview", element: <RebalanceSummary /> },
              { path: "trades", element: <RebalanceTrades /> },
              {
                path: "household-details",
                element: <RebalanceHouseholdDetails />,
              },
              {
                path: "model-trading",
                element: <RebalanceHouseholdModelTrading />,
              },
              {
                path: "cash-billing",
                element: <RebalanceHouseholdCashBilling />,
              },
              {
                // APP-1241 -- v3 explain UI is the default. Rebalances
                // predating v3 emission show an empty state linking to
                // the legacy view at `explain/old`.
                path: "explain",
                element: <RebalanceHouseholdExplainV3 />,
              },
              {
                path: "explain/old",
                element: <RebalanceHouseholdExplain />,
              },
            ],
          },
        ],
      },
      {
        path: "cash/*",
        element: (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
        handle: { crumb: () => "Cash" },
        children: [
          { index: true, element: <Navigate to="accounts" replace /> },
          {
            path: "accounts",
            element: <AccountCashSettings />,
            handle: { crumb: () => "Accounts" },
          },
          {
            path: "settings",
            element: <Outlet />,
            handle: { crumb: () => "Cash Settings" },
            children: [
              { index: true, element: <CashSettings /> },
              {
                path: ":cashSettingId",
                element: <CashSettingInfo />,
                handle: { crumb: () => "Details" },
              },
            ],
          },
          {
            path: "predictions",
            element: <Outlet />,
            handle: { crumb: () => "Recurring Cash Predictions" },
            children: [
              { index: true, element: <RecurringCashPredictions /> },
              {
                path: "new",
                element: <CreateForecastedTransfer />,
                handle: { crumb: () => "Create Forecasted Transfer" },
              },
            ],
          },
        ],
      },
      {
        path: "/clients",
        element: (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
        handle: { crumb: () => "Clients" },
        children: [
          { index: true, element: <Navigate to="households" replace /> },
          {
            path: "households",
            element: (
              <ProtectedRoute>
                <Outlet />
              </ProtectedRoute>
            ),
            handle: { crumb: () => "Households" },
            children: [
              {
                index: true,
                element: (
                  <GoRedirect>
                    <Households />
                  </GoRedirect>
                ),
              },
              {
                path: "mapping",
                element: <HouseholdMapping />,
                handle: { crumb: () => "Data Connections" },
              },
              {
                path: "new",
                element: <CreateHousehold />,
                handle: { crumb: () => "New" },
              },
              {
                path: "household-groups",
                element: <Outlet />,
                handle: { crumb: () => "Household Groups" },
                children: [
                  { index: true, element: <HouseholdGroups /> },
                  {
                    path: ":groupId",
                    element: <HouseholdGroupInfo />,
                    handle: { crumb: () => "Details" },
                  },
                ],
              },
              {
                path: ":householdId",
                element: <HouseholdInfo />,
                handle: { crumb: () => "Details" },
                children: [
                  {
                    index: true,
                    element: <Navigate to="overview" replace />,
                  },
                  { path: "overview", element: <HouseholdOverview /> },
                  { path: "portfolio", element: <HouseholdPortfolio /> },
                  {
                    path: "cash-billing",
                    element: <Outlet />,
                    children: [
                      { index: true, element: <HouseholdCashBilling /> },
                      {
                        path: ":accountId",
                        element: <HouseholdAccountCashSettings />,
                      },
                    ],
                  },
                  {
                    path: "model-trading",
                    element: <HouseholdModelTrading />,
                  },
                  { path: "tax", element: <HouseholdTax /> },
                  {
                    path: "tax-rmd",
                    element: <Navigate to="../tax" replace />,
                  },
                  { path: "profile", element: <HouseholdProfile /> },
                  { path: "portal", element: <HouseholdPortal /> },
                  { path: "todos", element: <HouseholdTasks /> },
                  {
                    path: "transactions",
                    element: <HouseholdTransactions />,
                  },
                  { path: "activity", element: <HouseholdActivity /> },
                ],
              },
            ],
          },
          {
            path: "accounts",
            element: (
              <ProtectedRoute>
                <Outlet />
              </ProtectedRoute>
            ),
            handle: { crumb: () => "Accounts" },
            children: [
              {
                index: true,
                element: (
                  <GoRedirect>
                    <Accounts />
                  </GoRedirect>
                ),
              },
              {
                path: "mapping",
                element: <AccountsHouseholdsMapping />,
                handle: { crumb: () => "Assignment" },
              },
              {
                path: "tax-classification",
                element: <BulkTaxClassification />,
                handle: { crumb: () => "Tax Classification" },
              },
              {
                path: ":accountId",
                element: <AccountInfo />,
                handle: { crumb: () => "Details" },
                children: [
                  {
                    index: true,
                    element: <Navigate to="overview" replace />,
                  },
                  { path: "overview", element: <AccountOverview /> },
                  { path: "portfolio", element: <AccountPortfolio /> },
                  {
                    path: "cash-billing",
                    element: <AccountCashBillingSettings />,
                  },
                  {
                    path: "model-trading",
                    element: <AccountModelTrading />,
                  },
                  { path: "tax", element: <AccountTax /> },
                  {
                    path: "tax-rmd",
                    element: <Navigate to="../tax" replace />,
                  },
                  { path: "profile", element: <AccountProfile /> },
                  {
                    path: "transactions",
                    element: <AccountTransactions />,
                  },
                  { path: "activity", element: <AccountActivity /> },
                ],
              },
            ],
          },
          {
            path: "contacts",
            element: (
              <ProtectedRoute>
                <Outlet />
              </ProtectedRoute>
            ),
            handle: { crumb: () => "Contacts" },
            children: [
              { index: true, element: <Contacts /> },
              {
                path: "mapping",
                element: <ContactMapping />,
                handle: { crumb: () => "Data Connections" },
              },
              {
                path: "new",
                element: <CreateContact />,
                handle: { crumb: () => "New" },
              },
              {
                path: ":contactId",
                element: <ContactInfo />,
                handle: { crumb: () => "Details" },
              },
            ],
          },
        ],
      },
      {
        path: "/profile",
        element: (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
        handle: { crumb: () => "Profile" },
        children: [
          { index: true, element: <UserProfile /> },
          {
            path: "create",
            element: <CreateUser />,
            handle: { crumb: () => "Create User" },
          },
        ],
      },
      {
        path: "/release-notes",
        element: (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
        handle: { crumb: () => "Release Notes" },
        children: [{ index: true, element: <ReleaseLog /> }],
      },
      {
        path: "/client-onboarding",
        element: <Navigate to="/help/getting-started/welcome" replace />,
      },
      {
        path: "/internal-docs",
        element: (
          <ProtectedRoute>
            <AdminDocsRoute />
          </ProtectedRoute>
        ),
        children: [
          { index: true, element: <DocsPage /> },
          { path: "*", element: <DocsPage /> },
        ],
      },
      {
        // APP-1282 (s-admin-authz-shell-advice-019e9cbb): staff-only admin
        // surface. StaffRoute gates on the `Advice Cloud Staff` role and
        // fails closed; the empty shell renders no firm data in this slice.
        // Sibling slices (list / exceptions / viewer) mount under it.
        path: "/admin",
        element: (
          <ProtectedRoute>
            <StaffRoute />
          </ProtectedRoute>
        ),
        handle: { crumb: () => "Admin" },
        children: [
          {
            // AdminShell is the layout for the staff surface; sibling slices
            // (list / exceptions / viewer) mount in its nested <Outlet/>.
            element: <AdminShell />,
            children: [
              { index: true, element: null },
              {
                // APP-1282 Job 2 (s-firm-scoped-admin-proposal-019ea1d9):
                // staff-gated, firm-scoped, read-only rebalance list. A firm
                // selector + reused RQL `q` controls; rows deep-link to the
                // Job-4 Explain viewer.
                path: "rebalances",
                element: <AdminRebalanceList />,
                handle: { crumb: () => "Rebalances" },
              },
              {
                // APP-1282 Job 4 (s-read-only-admin-explain-019ea1c7):
                // read-only cross-firm v3 Explain viewer. The id-less path
                // presents the rebalance-id input (R14/R15); the id path
                // renders the v3 tree read-only.
                path: "rebalances/explain",
                element: <AdminRebalanceExplain />,
                handle: { crumb: () => "Explain" },
              },
              {
                path: "rebalances/:rebalanceId/explain",
                element: <AdminRebalanceExplain />,
                handle: { crumb: () => "Explain" },
              },
            ],
          },
        ],
      },
      {
        path: "/firm/*",
        element: (
          <ProtectedRoute>
            <FirmHeading />
            <Outlet />
          </ProtectedRoute>
        ),
        handle: { crumb: () => "Firm" },
        children: [
          { index: true, element: <Navigate to="info" replace /> },
          {
            path: "info",
            element: <FirmInfo />,
            handle: { crumb: () => "Settings" },
          },
          {
            path: "security-category-asset-class",
            element: <CategoryAssetClass />,
            handle: { crumb: () => "Category to Asset Class Mapping" },
          },
          {
            path: "asset-class-risk-allocations",
            element: <RiskAllocationsAssetClass />,
            handle: { crumb: () => "Asset Class to Risk Mapping" },
          },
          {
            path: "security-master",
            element: <Outlet />,
            handle: { crumb: () => "Security Master" },
            children: [
              { index: true, element: <SecurityMaster /> },
              {
                path: ":symbol",
                element: <SecurityDetails />,
                // The page heads itself with the security, as the household
                // page does, so the Firm heading does not show (APP-1486).
                handle: { crumb: () => "Security", hideFirmHeading: true },
              },
            ],
          },
          {
            path: "risk",
            element: <FirmRisk />,
            handle: { crumb: () => "Risk Levels" },
          },
          {
            path: "risk/asset-class",
            element: <FirmRiskAssetClass />,
            handle: { crumb: () => "Risk Asset Class" },
          },
          {
            path: "risk/security-category",
            element: <FirmRiskSecurityCategory />,
            handle: { crumb: () => "Risk Security Category" },
          },
          {
            path: "trades/minimum-size",
            element: <MinimumTradeSizes />,
            handle: { crumb: () => "Minimum Trade Sizes" },
          },
          {
            path: "slant-billing-fields",
            element: <SlantBillingFields />,
            handle: { crumb: () => "Billing Fields" },
          },
          {
            path: "activity",
            element: <FirmActivity />,
            handle: { crumb: () => "Activity" },
          },
        ],
      },
      {
        path: "/billing",
        element: (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
        handle: { crumb: () => "Billing" },
        children: [
          { index: true, element: <Navigate to="summary" replace /> },
          {
            path: "summary",
            element: <BillingSummary />,
            handle: { crumb: () => "Details" },
          },
          {
            path: "reports",
            element: <Outlet />,
            handle: { crumb: () => "Billing Reports" },
            children: [
              { index: true, element: <BillingReportsTable /> },
              {
                path: "run",
                element: <CreateBillingReport />,
                handle: { crumb: () => "Run Billing" },
              },
              {
                path: ":reportId",
                element: <BillingReportInfo />,
                handle: { crumb: () => "Details" },
              },
            ],
          },
          {
            path: "fee-structure",
            element: <Outlet />,
            handle: { crumb: () => "Fee Structures" },
            children: [
              { index: true, element: <FeeStructureTable /> },
              {
                path: ":feeStructureId",
                element: <FeeStructureInfo />,
                handle: { crumb: () => "Detail" },
              },
            ],
          },
          {
            path: "billing-minimums",
            element: <Outlet />,
            handle: { crumb: () => "Billing Minimums" },
            children: [
              { index: true, element: <BillingMinimumTable /> },
              {
                path: ":billingMinimumId",
                element: <BillingMinimumInfo />,
                handle: { crumb: () => "Detail" },
              },
            ],
          },
          {
            path: "billing-splits",
            element: <Outlet />,
            handle: { crumb: () => "Fee Splits" },
            children: [
              { index: true, element: <BillingSplitsTable /> },
              {
                path: ":billingSplitId",
                element: <BillingSplitsInfo />,
                handle: { crumb: () => "Detail" },
              },
            ],
          },
          {
            path: "asset-exclusion",
            element: <Outlet />,
            handle: { crumb: () => "Asset Exclusion" },
            children: [
              { index: true, element: <AssetExclusionTable /> },
              {
                path: ":assetExclusionId",
                element: <AssetExclusionInfo />,
                handle: { crumb: () => "Detail" },
              },
            ],
          },
        ],
      },
      {
        path: "/reports",
        element: (
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        ),
        handle: { crumb: () => "Reports" },
        children: [
          { index: true, element: <Navigate to="batches" replace /> },
          {
            path: "batches",
            element: <ReportBatches />,
            handle: { crumb: () => "Batches" },
          },
          {
            path: "new",
            element: <CreateReport />,
            handle: { crumb: () => "Create" },
          },
          {
            path: "templates",
            handle: { crumb: () => "Templates" },
            children: [
              { index: true, element: <ReportTemplates /> },
              {
                path: ":templateId",
                element: <ReportTemplateInfo />,
                handle: { crumb: () => "Create" },
              },
            ],
          },
          {
            path: "exports",
            handle: { crumb: () => "Data Exports" },
            children: [
              { index: true, element: <DataExports /> },
              {
                path: "balances",
                element: <ExportAccountBalances />,
                handle: { crumb: () => "Export Balances" },
              },
              {
                path: "positions",
                element: <ExportAccountPositions />,
                handle: { crumb: () => "Export Positions" },
              },
              {
                path: "firm-positions",
                element: <ExportFirmPositions />,
                handle: { crumb: () => "Export Firm Positions" },
              },
              {
                path: "13f",
                element: <Export13f />,
                handle: { crumb: () => "Export 13F" },
              },
              {
                path: "13f-filing",
                element: <Filing13f />,
                handle: { crumb: () => "13-F Filing" },
              },
            ],
          },
          {
            path: "rmd",
            element: <FirmRMDReport />,
            handle: { crumb: () => "RMD" },
          },
          {
            path: ":reportBatchId",
            handle: { crumb: () => "Report" },
            children: [
              { index: true, element: <ReportBatchInfo /> },
              {
                path: "new",
                element: <CreateReport />,
                handle: { crumb: () => "Create" },
              },
              {
                path: ":reportId",
                element: <ReportInfo />,
                handle: { crumb: () => "Download" },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/help",
    element: (
      <ProtectedRoute>
        <HelpLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <HelpIndex /> },
      { path: ":section/:slug", element: <HelpArticle /> },
    ],
  },
  {
    path: "/integrations/login/:service",
    element: <IntegrationCredentials />,
  },
];

export default routes;
